import { get, post, put, del } from '../../api';
import { ansiToMoment } from '@utils/';

export const getFolgas = (page = 1) => {
  return get('/api/conectores/folgas');
};

export const getFolga = async (id) => {
  const res = await get(`/api/conectores/folga/${id}`);

  // eslint-disable-next-line
  res.map((folga) => {
    folga.periodo = [ansiToMoment(folga.dtInicio), ansiToMoment(folga.dtFim)];
  });

  return res;
};

export const putFolgas = (data) => {
  return put('/api/conectores/folgas', data);
};

export const postFolgas = (data) => {
  return post('/api/conectores/folgas', data);
};

export const deleteFolgas = (id) => {
  return del(`/api/conectores/folgas/${id}`);
};
